<template>
  <div class="pagemain">

    <div class="form-group">
      <div class="form-group-content">
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="貨幣">
              <div style="display: flex;">
                <el-select v-model="form.currency_id" placeholder="请选择">
                  <el-option v-for="item in currency" :key="item.id" :label="item.short_name+' '+item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>

          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="賬戶號碼" prop="account_num">
              <el-input v-model="form.account_num_format" @input="cardformat()" @change="cardformat" ref="cardInput" clearable></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="賬戶戶名" prop="account_name">
              <el-input v-model="form.account_name"></el-input>
            </el-form-item>

          </div>
          <div class="mm-col" style="margin-left: 20px;">
            <el-button @click="openchooseholder">使用戶主名稱</el-button>
            <el-dialog @closed="closechooseholder" title="導入戶主名稱" :visible.sync="chooseholder" width="95%" :append-to-body="true">
              <component @closeholder="closeholder" :is="chooseholder_component"></component>
            </el-dialog>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="銀行名稱" prop="bankinfo">
              <el-input v-model="form.bankinfo"></el-input>
            </el-form-item>
          </div>

        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="國家" prop="country_id">
              <countryselect :form="form"></countryselect>
            </el-form-item>
          </div>

        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="SWIFT CODE:" prop="swift_code">
              <el-input v-model="form.swift_code"></el-input>
            </el-form-item>
          </div>

        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="銀行代碼" prop="bankcode">
              <el-input v-model="form.bankcode"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="備註信息" prop="mark">
              <el-input v-model="form.mark"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <el-form-item label="使用狀態">
            <el-switch v-model="form.status" active-text="啟用" inactive-text="禁用">
            </el-switch>
          </el-form-item>

        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="餘額" prop="balance">
              <el-input v-model="form.balance" disabled=""></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="單日限額" prop="day_limit">
              <el-input v-model="form.day_limit"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="單月限額" prop="day_limit">
              <el-input v-model="form.month_limit"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="30日限額" prop="day_limit">
              <el-input v-model="form.limit_30"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="創建日期" prop="addtime">
              <el-date-picker v-model="form.addtime" type="date" placeholder="選擇日期" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>


<script>


import chooseholder from './ChooseHolder.vue';
import countryselect from '@/components/CountrySelect.vue';
export default {
  components: {
    chooseholder,
    countryselect
  },
  props: ['form'],
  data () {
    return {
      loading: false,
      chooseholder: false,
      chooseholder_component: '',
      currency: [],
    };
  },
  methods: {
    cardformat () {
      let val = this.form.account_num_format;
      this.formatCardNumber(this.form, val);
    },
    pageback () {
      this.$router.go(-1);
    },
    closeholder (holder) {

      this.chooseholder = false;
      this.chooseholder_component = '';
      this.form.account_name = holder.name;

    },
    closechooseholder () {
      this.chooseholder = false;
      this.chooseholder_component = '';
    },
    openchooseholder () {
      this.chooseholder = true;
      this.chooseholder_component = chooseholder;
    },
    getCurrency () {
      this.post('/api/bank/getcurrency', {

      }).then(response => {
        if (response.length > 0) {
          this.currency = response.filter(item => {
            if (item.short_name == 'HKD' || item.short_name == 'CNY') {
              return false;
            } else {
              return true;
            }
          });
          this.form.currency_id = 3;
        } else {
          this.currency = [];
        }
      }).catch(error => {
        console.log(333);
      });
    },

  },
  created () {
    this.getCurrency();
  },
  watch: {
    'form.account_num_format' (val) {
      if (val) {
        this.form.account_num = this.mytrim(val);
      } else {
        this.form.account_num = '';
      }
    },
  }
};
</script>




<style scoped>
.mm-row {
}

.currencyimg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: block;
}
</style>
